// src/routes/config/candidateRoutesConfig.ts
import { lazy } from 'react';

// ✅ Lazy-loaded route components
// Update the import path to the correct location of the Candidate component
// Update the import path below to the correct location of CandidateDashboard
const CandidateDashboard = lazy(() => import('../../pages/CandidatePortal/CandidateDashboard'));
const CandidateProfile = lazy(() => import('../../pages/CandidatePortal/CandidateProfile'));
const AvailableJobs = lazy(() => import('../../pages/Jobs/AvailableJobs'));
const IndividualJob = lazy(() => import('../../pages/Jobs/IndividualJob'));
const ResumeTest = lazy(() => import('../../pages/Jobs/ResumeTest'));
const AppliedJobs = lazy(() => import('../../pages/Jobs/AppliedJob'));
const JobApply = lazy(() => import('../../pages/Jobs/PublicJobApply'));

// ✅ Route config array
const candidateRoutesConfig = [
  {
    path: '/v1/candidate/dashboard',
    component: CandidateDashboard,
  },
  {
    path: '/v1/candidate/profile',
    component: CandidateProfile,
  },
  {
    path: '/v1/jobs/available',
    component: AvailableJobs,
  },
  {
    path: '/v1/jobs/:id',
    component: IndividualJob,
  },
  {
    path: '/candidate/resume-test',
    component: ResumeTest,
  },
  {
    path: '/v1/jobs/applied',
    component: AppliedJobs,
  },
  {
    // Auth-gated apply form. Anonymous visitors get bounced to signup via
    // applyHref() in PublicJobDetail. ProtectedRoute enforces the auth check.
    path: '/v1/jobs/:jobId/apply',
    component: JobApply,
  },
];

if (import.meta.env.DEV) {
  candidateRoutesConfig.forEach(({ path, component }) => {
    if (!component) {
      console.error(`❌ Component for route path "${path}" is undefined or invalid.`);
    }
  });
}

export default candidateRoutesConfig;
